import React, { useState } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";

const MilagritoSwitch = withStyles({
	switchBase: {
		color: "darkgray",
		"&$checked": {
			color: "#52d869",
		},
		"&$checked + $track": {
			backgroundColor: "#52d869",
		},
	},
	checked: {},
	track: {
		backgroundColor: "gray",
	},
})(Switch);

export default function CashToggleForm(props) {
	const { register, handleSubmit } = useForm();
	const { data, onSubmit, isLoading } = props;
	// eslint-disable-next-line
	const [isEnabled, setIsEnabled] = useState(data.isCashEnabled);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<FormControlLabel
				control={<MilagritoSwitch defaultChecked={isEnabled} />}
				label="Activar o desactivar efectivo"
				labelPlacement="start"
				inputRef={register}
				name="isCashEnabled"
			/>
			<br />
			<ButtonWithStyle disabled={isLoading} type="submit">
				Guardar
			</ButtonWithStyle>
		</form>
	);
}
